<template>
    <Section
        class="rich-text-slice"
        :class="[{'section-padding': data.primary.background !== 'white'}, 'bg-' + data.primary.background]"
        width="sm"
    >
        <div
            :class="[data.primary.list_icon, `text-${data.primary.text_align}`]"
            class="rich-text"
            v-html="$prismic.asHtml(data.primary.content)"
        />
    </Section>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {}
        }
    }
};
</script>
